import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { boId: String }

  connect() {
  }

  openChat() {
    const boId = this.boIdValue;
    this.openZendeskChat(boId);
  }

  openZendeskChat(boId) {
    let ticket_id = `${boId}_${this.generateUUID()}`;

    window.zE('messenger', 'open');
    window.zE('messenger:set', 'conversationTags', [
      `bo_${boId}`,
      'business_inquiry'
    ]);
    window.zE('messenger:set', 'conversationFields', [
      { id: 23796364462738, value: boId.toString() },
      { id: 23860507256338, value: ticket_id }
    ]);

    setTimeout(() => {
      const iframe = document.querySelector('iframe[title="Messaging window"], iframe[title="Ventana de mensajería"]');
      if (iframe) {
        try {
          const backButton = iframe.contentDocument.querySelector('[data-garden-id="buttons.icon_button"]');
          if (backButton && backButton.offsetParent !== null) {
            backButton.click();
          }

          const newConvButton = iframe.contentDocument.evaluate(
            "//button[.//span[contains(text(), 'New conversation') or contains(text(), 'Nueva conversación')]]",
            iframe.contentDocument,
            null,
            XPathResult.FIRST_ORDERED_NODE_TYPE,
            null
          ).singleNodeValue;

          if (newConvButton) {
            newConvButton.click();
          }
        } catch (e) {
          console.log(e);
        }
      }
    }, 1250);

    console.log(`Business Opportunity ${boId} inquiry started`);
    console.log(`Ticket tracker ${ticket_id} inquiry started`);
  }

  startSimpleChat() {
    window.zE('messenger', 'open');

    setTimeout(() => {
      const iframe = document.querySelector('iframe[title="Messaging window"], iframe[title="Ventana de mensajería"]');
      if (iframe) {
        try {
          const backButton = iframe.contentDocument.querySelector('[data-garden-id="buttons.icon_button"]');
          if (backButton && backButton.offsetParent !== null) {
            backButton.click();
          }

          const newConvButton = iframe.contentDocument.evaluate(
            "//button[.//span[contains(text(), 'New conversation') or contains(text(), 'Nueva conversación')]]",
            iframe.contentDocument,
            null,
            XPathResult.FIRST_ORDERED_NODE_TYPE,
            null
          ).singleNodeValue;

          if (newConvButton) {
            newConvButton.click();
          }
        } catch (e) {
          console.log(e);
        }
      }
    }, 1250);
  }

  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}
